module.exports = __webpack_public_path__ + "static/media/Tietoa_logo.6a17ad9c.svg";